"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VolumeOffIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.777.22a.77.77 0 01-.01 1.09L1.311 15.768a.77.77 0 01-1.09.01.77.77 0 01.01-1.09l2.457-2.457c-.365-.047-.646-.34-.646-.694v-7c0-.386.336-.7.75-.7h3.55L11.42 1.13a.797.797 0 01.748.002.693.693 0 01.374.605v.64L14.687.231a.77.77 0 011.09-.01zM6.65 12.4l4.72 2.506a.793.793 0 00.754-.003.708.708 0 00.376-.617V6.6l-5.85 5.8z"
  })))
});
VolumeOffIcon.displayName = 'VolumeOffIcon';
var _default = exports.default = VolumeOffIcon;